module.exports = __webpack_public_path__ + "img/student6.a643c0f2.png";